/**
 * useHeartbeat — fire-and-forget activity heartbeat hook.
 *
 * Calls POST /api/prep-os/heartbeat once per user-IST-day per (activity, content_id).
 * The backend is idempotent — calling 50 times today only creates 1 row.
 *
 * Usage:
 *   useHeartbeat({ activity: 'dashboard_open', module: 'dashboard' });
 *   useHeartbeat({ activity: 'chapter_read', module: 'prelims', contentId: chapterId });
 */
import { useEffect } from 'react';
import managedAxios from '@/utils/managedAxios';
import { API_BASE } from '@/services/api';

export default function useHeartbeat({ activity, module, contentId, enabled = true } = {}) {
  useEffect(() => {
    if (!enabled || !activity) return;

    const params = new URLSearchParams({ activity });
    if (module) params.append('module', module);
    if (contentId) params.append('content_id', contentId);

    const url = `${API_BASE}/prep-os/heartbeat?${params.toString()}`;
    managedAxios
      .post(url)
      .catch(() => { /* silent — heartbeat must never disturb user */ });
  }, [activity, module, contentId, enabled]);
}
